import styled from "styled-components";
import { textTheme } from "../../../theme";
import { createMuiTheme, createStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core";

export const Title = styled.label`
  display: flex;
  margin-bottom: 7px;
  ${textTheme.subtitle2}
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 40px;
`;

export const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      width: 183,
      height: 42,
      border: "1px solid rgba(195, 203, 205, 0.35)",
      boxSizing: "border-box",
      borderRadius: "4px",
    },
    root: {
      fontFamily: "Open Sans",
      fontSize: "14px",
      fontWeight: "700" as any,
      lineHeight: "18px",
      letterSpacing: "0.3px",
      width: "fit-content",
      color: "#C3CBCD",
      backgroundColor: "#FFFFFF",
      border: "1px solid #C3CBCD",
      borderRadius: "20px",
      margin: "20px 20px 20px 50px",
      padding: "11px 20px 11px 17px",
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
    selected: {
      fontFamily: "Open Sans",
      fontSize: "14px",
      fontWeight: "700" as any,
      lineHeight: "18px",
      letterSpacing: "0.3px",
      width: "fit-content",
      color: "#FFFFFF",
      backgroundColor: "#0A8EDF !important",
      border: "1px solid #0A8EDF",
      borderRadius: "20px",
      margin: "20px 20px 20px 50px",
      padding: "11px 20px 11px 17px",
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
    rootAny: {
      fontFamily: "Open Sans",
      fontSize: "14px",
      fontWeight: "700" as any,
      lineHeight: "18px",
      letterSpacing: "0.3px",
      width: "fit-content",
      color: "#C3CBCD",
      backgroundColor: "#FFFFFF",
      border: "1px solid #C3CBCD",
      borderRadius: "20px",
      marginLeft: "20px",
      marginTop: "15px",
      padding: "11px 20px 11px 17px",
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
    selectedAny: {
      fontFamily: "Open Sans",
      fontSize: "14px",
      fontWeight: "700" as any,
      lineHeight: "18px",
      letterSpacing: "0.3px",
      width: "fit-content",
      color: "#FFFFFF",
      backgroundColor: "#0A8EDF !important",
      border: "1px solid #0A8EDF",
      borderRadius: "20px",
      marginLeft: "20px",
      marginTop: "15px",
      padding: "11px 20px 11px 17px",
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
    inputRoot: {
      fontFamily: "Open Sans",
      fontSize: "13px",
      fontWeight: "400" as any,
      lineHeight: "20px",
      letterSpacing: "0.2px",
      height: "42px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      backgroundColor: "#FFFFFF",
      borderRadius: "4px",
    },
    input: {
      textAlign: "left",
      paddingLeft: "16px",
      backgroundColor: "#FFFFFF",
      width: "130px",
    },
    inputFormControl: {},
  })
);

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 700,
      fontFamily: "Open Sans",
      marginTop: "-5px",
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
} as const;

export const MuiTheme = createMuiTheme({
  overrides: {
    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: "#FFFFFF !important",
        },
      },
    },
  },
});
